export default [
  {
    name: "1",
    id: "bbc0d6c6-df80-4068-aa5d-3c110aff82d9",
  },
  {
    name: "2",
    id: "4522aa8f-fb40-4ff7-ac17-db1500201c2b",
  },
  {
    name: "3",
    id: "06338729-8d88-442a-a4e0-4b6b0bfc51fe",
  },
  {
    name: "4",
    id: "0258fd7a-dccb-4fc0-a650-a919e92bfc5e",
  },
  {
    name: "5",
    id: "fd8714b8-3a6c-427b-85e1-b4378ef4bd53",
  },
  {
    name: "6",
    id: "61b17e07-d3a2-4d1d-b105-9aec64ebf409",
  },
  {
    name: "7",
    id: "880fff1c-05cc-4352-9610-494a4dbbb7ec",
  },
  {
    name: "8",
    id: "a0f33c20-eaa0-408f-a7d0-5db6cd470319",
  },
  {
    name: "9",
    id: "ad99c414-57d3-4a77-aa8f-5833f79be6e8",
  },
  {
    name: "10",
    id: "8f395bcd-3bfc-4606-9d95-a3b4c5ccb004",
  },
  {
    name: "11",
    id: "eedce3a0-3e94-4ed0-9b52-8e467fbcd298",
  },
  {
    name: "12",
    id: "519af230-9e62-40a0-9c8d-66bfae507c75",
  },
  {
    name: "13",
    id: "71f3daba-5b87-4897-a1b7-15626d62cc2c",
  },
  {
    name: "14",
    id: "23624861-d614-4d41-8670-f94a60f649cc",
  },
  {
    name: "15",
    id: "ec2018d2-6127-486f-8e3d-1228ec3e95b3",
  },
  {
    name: "16",
    id: "b64160fd-3cd4-4782-9bf1-098cf047ebdc",
  },
  {
    name: "17",
    id: "075ee26a-710a-4d38-9a69-442f859e0264",
  },
  {
    name: "18",
    id: "75eb5187-3155-4c03-b418-e03ab27f439a",
  },
  {
    name: "19",
    id: "1f300d79-4939-47fa-9706-b770291f7fc9",
  },
  {
    name: "20",
    id: "4e6f8861-136b-487f-8c4f-d88619faa860",
  },
  {
    name: "21",
    id: "bf27fdca-4240-40ca-861b-5f25b991effb",
  },
  {
    name: "22",
    id: "e45e3f64-dcec-4ec4-aa64-1635bdcc7981",
  },
  {
    name: "23",
    id: "3e5536d5-aef3-4002-9bdb-582c89ca9d9d",
  },
];
